import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import storePersist from '../../../../../../redux/storePersist';
import PageLoader from '../../../../../../components/PageLoader';
import { organizationUnits } from '../../../../../../redux/organizationUnits/action';
import {  selectOrganizationUnitsQueryItems } from '../../../../../../redux/organizationUnits/selector';
import OrganizationUnitComponent from '../components/organization-unit.component';
import UploadFiles from '../../../../../../models/UploadFile';
import { settings } from '../../../../../../redux/settings/actions';
import { selectCurrent } from '../../../../../../redux/settings/selectors';
import { deepCopy } from '../../../../../../common/services/common.service';
import { timeZones } from '../../../../../../redux/time-zone/action';
import { selectTimeZonesListItems } from '../../../../../../redux/time-zone/selector';

let currentChange: any = {}
const ManagementOrganizationUnit = () => {  
  const navigate = useNavigate()
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [
    openConfirmationFile,
    setOpenConfirmationFile
  ] = React.useState(false);
  const [
    openConfirmationLogoFile,
    setOpenConfirmationLogoFile
  ] = React.useState(false);
  const [
    openConfirmationFavFile,
    setOpenConfirmationFavFile
  ] = React.useState(false);
  const [
    logoFiles,
    setLogoFiles
  ] = useState<any>([])
  const [
    favFiles,
    setFavFiles
  ] = useState<any>([])
  const [
    socialProfiles,
    setSocialProfiles
  ] = useState([])
  const [
    brandMappings,
    setBrandMappings
  ] = useState<any>([])
  const organizationUnitQuery = useSelector(selectOrganizationUnitsQueryItems)
  const librariesItems = storePersist?.get("library")?.current;
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
const timeZonesItems = useSelector(selectTimeZonesListItems)
const [
    selectedAddress,
    setSelectedAddress
  ] = useState<any>({

    PrimaryAddress: {},
    BillingAddress: {},
    ShippingAddress: {}

  })  
  const [
    openImageFile,
    setOpenImageFile
  ] = useState<any>([]);
  const [
    organizationUnitImageIndex,
    setOrganizationUnitImageIndex
  ] = useState<any>([])
  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);
  const [
    selectedOrganizationUnit,
    setSelectedOrganizationUnit
  ] = useState<any>([])
  const fetchOrganizationUnitsQueryById= ()=>{
    dispatch(organizationUnits.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/query`,entity:'organizationUnits',jsonData:{
          
    Records: [
      {
        Id: parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }
  const handleFormLogoItemChange = ({ value, field, idx, cardValue, idx1 }: any) => {
    const items = deepCopy(cardValue.Logos);
    items[idx] = { ...items[idx], [field]: value };
    setLogoFiles(items);
    const updatedCardValue = [...brandMappings];
    updatedCardValue[idx1] = { ...cardValue, Logos: items };
    setBrandMappings(updatedCardValue);
  }
  const handleFormFavItemChange = ({ value, field, idx, cardValue, idx1 }: any) => {
    const items = deepCopy(cardValue.Favicons);
    items[idx] = { ...items[idx], [field]: value };
    setFavFiles(items);
    const updatedCardValue = [...brandMappings];
    updatedCardValue[idx1] = { ...cardValue, Favicons: items };
    setBrandMappings(updatedCardValue);
  }
  const handleFormSocialProfileItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(socialProfiles);
    let item = items[idx];
    item = { ...item, [field]: value }
    items[idx] = item;
    currentChange = { value, field, idx }
    setSocialProfiles(items);
  }
  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedOrganizationUnit({ ...selectedOrganizationUnit, [fields[0]]: value });
    setSelectedAddress({ ...selectedAddress, [fields[0]]: value });
  }
  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedOrganizationUnit({ ...selectedOrganizationUnit, [field]: event })
  }
  const handleFormItemBrandChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(brandMappings);
    let item = items[idx];
    item = { ...item, [field]: value }
    items[idx] = item;
    currentChange = { value, field, idx }
    setBrandMappings(items);
  }
  const handleClose = () => {
    if(openConfirmationFile){
      setOpenConfirmationFile(false) 
    } else if(openConfirmationLogoFile){
      setOpenConfirmationLogoFile(false)
    } else if(openConfirmationFavFile){
      setOpenConfirmationFavFile(false)
    }
    dispatch(settings.set({ getUploadFiles: 'close' }))
  }

  const addNewRow = ({ selectedBrandsArg }: any) => {
    const localSelectedBrands = deepCopy(selectedBrandsArg)
    const newsBrand = {
      Id: 0,
      Name: '',
      Description: '',
        Logos: [
          {
          Url: '',
          Size: '',
          Background: '', 
        }
      ],
        Favicons: [
          {
            Url: '',
            Size: '',
            Background: '', 
          }
        ],
        Branding: {
          Primary: { },
          Secondary: { },
          Tertiary: { },
          Ghost: { }
        }
    }
    if (localSelectedBrands.length === 0 ||
      localSelectedBrands[localSelectedBrands?.length - 1]?.Name !== ''
    ) {
      localSelectedBrands?.push(newsBrand);
    }

    return localSelectedBrands
  }
  const addNewLogoFilesRow = ({ selectedLogoFilesArg, brandMapping, idx, idx1 }: any) => {
    const localSelectedlogo = deepCopy(selectedLogoFilesArg)
    const newSelectedLogo = {
      Url: '',
      Size: '',
      Background: '',     
    }
    
    if (localSelectedlogo.length === 0 ||
      brandMapping[idx1]?.Logos[brandMapping[idx1].Logos?.length - 1]?.Url !== ''
    ) {
      
      brandMapping[idx1]?.Logos?.push(newSelectedLogo)
    }
   
    return localSelectedlogo
  }
  const addNewFavFilesRow = ({ selectedFavFilesArg, brandMapping, idx, idx1 }: any) => {
    const localSelectedfav = deepCopy(selectedFavFilesArg)
    const newSelectedFav = {
      Url: '',
      Size: '',
      Background: '',     
    }
    
    if (localSelectedfav.length === 0 ||
      brandMapping[idx1]?.Favicons[brandMapping[idx1].Favicons?.length - 1]?.Url !== ''
    ) {
      
      brandMapping[idx1]?.Favicons?.push(newSelectedFav)
    }
   
    return localSelectedfav
  }
  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      FileTypeId: 0,
      OwnerTypeId: 3,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }

    return localSelectedmedia
  }
  const addNewSocialProfilesRow = ({ selectedSocialProfilesFilesArg }: any) => {
    const localSelectedSocialProfiles = deepCopy(selectedSocialProfilesFilesArg)
    const newsSelectedSocialProfiles = {
      Id: 0,
      OwnerTypeId: 110,
      OwnerId: parmas?.id,
      SocialProfileTypeId: 0,
      SocialProfileUrl: ''
    }
    if (localSelectedSocialProfiles.length === 0 ||
      localSelectedSocialProfiles[localSelectedSocialProfiles?.length - 1]?.SocialProfileTypeId !== 0
    ) {
      localSelectedSocialProfiles?.push(newsSelectedSocialProfiles)
    }

    return localSelectedSocialProfiles
  }
  const setCombinationLogoInfo = async () => {
    let localSelectedLogo = deepCopy(logoFiles)
    localSelectedLogo.splice(
      currentChange.idx,
      1,
      { ...localSelectedLogo[currentChange.idx] }
    );
    localSelectedLogo = addNewLogoFilesRow({ selectedLogoFilesArg: localSelectedLogo, brandMapping : brandMappings ,idx1: currentChange.idx });
    currentChange.field = 'UrlDONE'
    setLogoFiles(localSelectedLogo)
  }
  const setCombinationFavInfo = async () => {
    let localSelectedFav = deepCopy(favFiles)
    localSelectedFav.splice(
      currentChange.idx,
      1,
      { ...localSelectedFav[currentChange.idx] }
    );
    localSelectedFav = addNewFavFilesRow({ selectedFavFilesArg: localSelectedFav, brandMapping : brandMappings ,idx1: currentChange.idx });
    currentChange.field = 'UrlDONE'
    setFavFiles(localSelectedFav)
  }
  const setCombinationMediaInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  const setCombinationSocialProfilesInfo = async () => {
    let localSelectedSocialProfiles = deepCopy(socialProfiles)
    localSelectedSocialProfiles.splice(
      currentChange.idx,
      1,
      { ...localSelectedSocialProfiles[currentChange.idx] }
    );
    localSelectedSocialProfiles = addNewSocialProfilesRow({ selectedSocialProfilesFilesArg: localSelectedSocialProfiles });
    currentChange.field = 'SocialProfileTypeIdDONE'
    setSocialProfiles(localSelectedSocialProfiles)
  }
  const setCombinationBrandInfo = async () => {
    let localSelectedbrands = deepCopy(brandMappings)
    localSelectedbrands.splice(
      currentChange.idx,
      1,
      { ...localSelectedbrands[currentChange.idx] }
    );
    localSelectedbrands = addNewRow({ selectedBrandsArg: localSelectedbrands });
    currentChange.field = 'NameDONE'
    setBrandMappings(localSelectedbrands)
  }
  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setCombinationMediaInfo()
      }
    },
    [mediaFiles]
  )
  useEffect(
    () => {
      if (currentChange.field === 'Url') {
        setCombinationLogoInfo()
      }
    },
    [currentChange.field,currentChange.idx]
  )
  useEffect(
    () => {
      if (currentChange.field === 'Url') {
        setCombinationFavInfo()
      }
    },
    [currentChange.field,currentChange.idx]
  )
  useEffect(
    () => {
      if ( currentChange.field === 'Name') {
        setCombinationBrandInfo()
      }
    },
    [brandMappings]
  )
  useEffect(
    () => {
      if (currentChange.field === 'SocialProfileTypeId') {
        setCombinationSocialProfilesInfo()
      }
    },
    [socialProfiles]
  )
  useEffect(
    () => {
        dispatch(timeZones.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/library/TimeZone`,entity:'timeZones',jsonData:{}
           })).then(()=>{
            if (parmas?.id > 0) {
              fetchOrganizationUnitsQueryById()
                setIsLoading(false)
                } else{
                  const localSelectedBrands = addNewRow({ selectedBrandsArg: brandMappings });
                  setBrandMappings(localSelectedBrands)
                  const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
                  setMediaFiles(localSelectedMedia)
                     const localSelectedLogo = addNewLogoFilesRow({ selectedLogoFilesArg: logoFiles,brandMapping : brandMappings ,idx1: 0  });
                  setLogoFiles(localSelectedLogo)
                  const localSelectedSocialProfiles = addNewSocialProfilesRow({ selectedSocialProfilesFilesArg: socialProfiles });
                  setSocialProfiles(localSelectedSocialProfiles)
                    setIsLoading(false) 
                }
          })
       
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedOrganizationUnit(organizationUnitQuery?.result?.items)
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: organizationUnitQuery?.result?.items?.MediaMappings?.MediaFiles });
        setMediaFiles(localSelectedMedia)
        const localSelectedSocialProfiles = addNewSocialProfilesRow({ selectedSocialProfilesFilesArg:  organizationUnitQuery?.result?.items?.MediaMappings?.SocialProfiles });
        setSocialProfiles(localSelectedSocialProfiles)
        const brandData: any = organizationUnitQuery?.result?.items.BrandMappings.map((item: any) => {
          const itemData = {
            Id: item?.Id,
            Name: item?.Name,
            Description: item?.Description,
            PrimaryColor: item?.Configurations?.Branding?.Primary?.Color,
            PrimaryBackgroundColor:item?.Configurations?.Branding?.Primary?.BackgroundColor,
            PrimaryBackgroundImage:item?.Configurations?.Branding?.Primary?.BackgroundImage,
            SecondaryColor: item?.Configurations?.Branding?.Secondary?.Color,
            SecondaryBackgroundColor:item?.Configurations?.Branding?.Secondary?.BackgroundColor,
            SecondaryBackgroundImage:item?.Configurations?.Branding?.Secondary?.BackgroundImage,
            TertiaryColor: item?.Configurations?.Branding?.Tertiary?.Color,
            TertiaryBackgroundColor:item?.Configurations?.Branding?.Tertiary?.BackgroundColor,
            TertiaryBackgroundImage:item?.Configurations?.Branding?.Tertiary?.BackgroundImage,
            GhostColor: item?.Configurations?.Branding?.Ghost?.Color,
            GhostBackgroundColor:item?.Configurations?.Branding?.Ghost?.BackgroundColor,
            GhostBackgroundImage:item?.Configurations?.Branding?.Ghost?.BackgroundImage,
            Logos: item?.Configurations?.Logos?.map((logoItem: any) => {
              return {
                Url: logoItem.Url,
                Size: logoItem.Size,
                Background: logoItem.Background,
              };
            }),
            Favicons: item?.Configurations?.Favicons?.map((favItem: any) => {
              return {
                Url: favItem.Url,
                Size: favItem.Size,
                Background: favItem.Background,
              };
            }),
          }
          return itemData
        })
        const localSelectedbrands = addNewRow({ selectedBrandsArg: brandData });
        setBrandMappings(localSelectedbrands)

        setSelectedAddress({ 
            PrimaryAddress: organizationUnitQuery?.result?.items?.PrimaryAddress,
            BillingAddress: organizationUnitQuery?.result?.items?.BillingAddress,
            ShippingAddress: organizationUnitQuery?.result?.items?.ShippingAddress})
            const updatedLogo = brandData.map((brandMapping: any, index: any) => {
              const localSelectedlogo = addNewLogoFilesRow({
                selectedLogoFilesArg:  brandMapping.Logos,
                brandMapping: localSelectedbrands,
                 idx: brandMapping.Logos.length,
                 idx1: index
              });
              return localSelectedlogo;
            });
        
            setLogoFiles(updatedLogo)
            const updatedFav = brandData.map((brandMapping: any, index: any) => {
              const localSelectedlogo = addNewFavFilesRow({
                selectedFavFilesArg:  brandMapping.Favicons,
                brandMapping: localSelectedbrands,
                 idx: brandMapping.Favicons.length,
                 idx1: index
              });
              return localSelectedlogo;
            });
            setFavFiles(updatedFav)
    }
    },
    [isQuery]
  ) 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )
    brandMappings.splice(
      brandMappings.length - 1,
      1
    )
    socialProfiles.splice(
      socialProfiles.length - 1,
      1
    )
    const brandData: any = brandMappings.map((item: any) => {
      if (item?.Logos?.length) {
        item.Logos.splice(item.Logos.length - 1, 1);
      }
      if (item?.Favicons?.length) {
        item.Favicons.splice(item.Favicons.length - 1, 1);
      }
      const itemData = {
        Id: item?.Id,
        Name: item?.Name,
        Description: item?.Description,
        Configurations:{
          Logos: item?.Logos?.map((logoItem: any) => {
            return {
              Url: logoItem.Url,
              Size: logoItem.Size,
              Background: logoItem.Background,
            };
          }),
          Favicons: item?.Favicons?.map((favItem: any) => {
            return {
              Url: favItem.Url,
              Size: favItem.Size,
              Background: favItem.Background,
            };
          }),
          Branding: {
            Primary: {
              Color: item?.PrimaryColor,
              BackgroundColor: item?.PrimaryBackgroundColor,
              BackgroundImage: item?.PrimaryBackgroundImage
            },
            Secondary: {
              Color: item?.SecondaryColor,
              BackgroundColor: item?.SecondaryBackgroundColor,
              BackgroundImage: item?.SecondaryBackgroundImage
            },
            Tertiary: {
              Color: item?.TertiaryColor,
              BackgroundColor: item?.TertiaryBackgroundColor,
              BackgroundImage: item?.TertiaryBackgroundImage
            },
            Ghost: {
              Color: item?.GhostColor,
              BackgroundColor: item?.GhostBackgroundColor,
              BackgroundImage: item?.GhostBackgroundImage
            },
           
        },
      }
       
      }
      return itemData
    })
    const organizationUnitData= {
   
      OrganizationUnitInfo:selectedOrganizationUnit?.OrganizationUnitInfo,
        PrimaryAddress:selectedAddress?.PrimaryAddress,
        IsUsePrimaryAddressAsBillingAddress: selectedOrganizationUnit?.IsUsePrimaryAddressAsBillingAddress || false,
        BillingAddress: selectedAddress?.BillingAddress,
        IsUsePrimaryAddressAsShippingAddress: selectedOrganizationUnit?.IsUsePrimaryAddressAsShippingAddress || false,
        ShippingAddress: selectedAddress?.ShippingAddress,
        MediaMappings: {
          MediaFiles: mediaFiles,
          Templates: selectedOrganizationUnit?.MediaMappings?.Templates || [],
          SocialProfiles: socialProfiles
        },
        BrandMappings:brandData
      }
      if (parmas?.id > 0) {
     dispatch(organizationUnits.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units`,entity:'organizationUnits',jsonData:{
          
    Records: [
      organizationUnitData
    ]
 
}})) .then(()=>{
    back()
  })
      }else{
        dispatch(organizationUnits.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units`,entity:'organizationUnits',jsonData:{
            
        Records: [
          organizationUnitData
        ]
      
    }})).then(()=>{
        back()
      })
      }
  }
 
const back=()=>{
  navigate('/management/organization/organization-management/organization-units')
} 
const deleteSelectedMedia = async (Item: any, index: any) => {

  if (Item.Id === 0) {
    mediaFiles?.splice(
      index,
      1
    )
  }
  handleClose()
}
const handleSubmit = (data: any) => {
  mediaFiles[organizationUnitImageIndex].FileMappingURL = data
  const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
  setMediaFiles(localSelectedMedia)
}
const changeImage = (idx: number, templateField: any, fileType: any) => {
  setOrganizationUnitImageIndex(idx)
  dispatch(settings.set({ getUploadFiles: 'open' }))
  setOpenConfirmationFile(true)
  setOpenFile({
    currentFileSrc: mediaFiles[idx][templateField],
    folder: 'Organizationunit',
    type: fileType
  })
}
const handleLogoSubmit = (data: any) => {
    
  const newLogoFiles = [...logoFiles];
    const logosArray = brandMappings[currentChange.idx1]?.Logos;
    logosArray[currentChange.idx].Url = data;
  const localSelectedLogo = addNewLogoFilesRow({
    selectedLogoFilesArg: newLogoFiles,
    brandMapping: brandMappings,
    idx: currentChange.idx, 
    idx1: currentChange.idx1,
    data: data
});
  setLogoFiles(localSelectedLogo)
}
const changeLogoImage = (idx: number, templateField: any, fileType: any, brandMaping: any, idx1: any) => {
  dispatch(settings.set({ getUploadFiles: 'open' }))
  setOpenConfirmationLogoFile(true)
  setOpenImageFile({
      currentFileSrc: brandMaping[idx1]?.Logos[idx][templateField],
      folder: 'Organizationunit',
      type: fileType
    })
    currentChange = { idx, templateField,idx1 }

  }

  const changeFavImage = (idx: number, templateField: any, fileType: any, brandMaping: any, idx1: any) => {
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenConfirmationFavFile(true)
    setOpenImageFile({
        currentFileSrc: brandMaping[idx1]?.Favicons[idx][templateField],
        folder: 'Organizationunit',
        type: fileType
      })
      currentChange = { idx, templateField,idx1 }
  
    }
const handleFavSubmit = (data: any) => {
    
  const newfavFiles = [...favFiles];
    const favsArray = brandMappings[currentChange.idx1]?.Favicons;
    favsArray[currentChange.idx].Url = data;
  const localSelectedFav = addNewFavFilesRow({
    selectedFavFilesArg: newfavFiles,
    brandMapping: brandMappings,
    idx: currentChange.idx, 
    idx1: currentChange.idx1,
    data: data
});
  setFavFiles(localSelectedFav)
}
    return (
        <>
{getUploadFiles == 'open' && openConfirmationFile && <UploadFiles  currentFilesSrc={openFile?.currentFileSrc}
    folder={openFile?.folder}
         handleClose={handleClose}
         handleFilesSubmit={handleSubmit}
         type={openFile?.type}
         ownerId={parmas?.id}
         />}
        {getUploadFiles == 'open' && openConfirmationLogoFile && <UploadFiles  currentFilesSrc={openFile?.currentFileSrc}
    folder={openImageFile?.folder}
         handleClose={handleClose}
         handleFilesSubmit={handleLogoSubmit}
         type={openImageFile?.type}
         ownerId={parmas?.id}
         />} 
         {getUploadFiles == 'open' && openConfirmationFavFile && <UploadFiles  currentFilesSrc={openFile?.currentFileSrc}
    folder={openImageFile?.folder}
         handleClose={handleClose}
         handleFilesSubmit={handleFavSubmit}
         type={openImageFile?.type}
         ownerId={parmas?.id}
         />} 
        {isLoading ? <PageLoader /> : 
          <OrganizationUnitComponent 
          handleFormSubmit={handleFormSubmit}
          back={back}
          onFormFavItemChange={handleFormFavItemChange}
          changeFavImage={changeFavImage}
          logoFiles={logoFiles}
          onFormLogoItemChange ={handleFormLogoItemChange}
          faviconSize={librariesItems?.FaviconSize}
          changeLogoImage={changeLogoImage}
          logoBackground={librariesItems.LogoBackground} 
          onFormItemBrandChange={handleFormItemBrandChange}
          brandMappings={brandMappings} 
          socialProfileType={librariesItems.SocialProfileType}
          onFormSocialProfileItemChange={handleFormSocialProfileItemChange}
          socialProfiles={socialProfiles}
          onFormItemChange={handleFormItemChange}
          fileTypes={librariesItems.FileType}
          deleteSelectedMedia={deleteSelectedMedia}
          changeImage={changeImage}
          mediaFiles={mediaFiles}
          id={parmas?.id}
          handleInnerbasicFormChange={handleInnerbasicFormChange}
          selectedAddress={selectedAddress}
          timeZones={timeZonesItems?.result?.items}
          currencyRoundingType={librariesItems.RoundingType}
          currencyCodeType={librariesItems.CurrencyCodeType}
          selectedOrganizationUnit={selectedOrganizationUnit}
          onInnerFormChange={handleInnerFormChange}
          /> 
    } 
          </>
    )
    
    }
   
    export default ManagementOrganizationUnit;